import type { MediaValue } from '../../../data/sources';
import { useSocialFeedSettings } from '../../../utils';
import { MediaCarousel } from './MediaCarousel';
import { MediaImage } from './MediaImage';
import { MediaLink } from './MediaLink';
import type { PickedMediaImageProps } from './media-video';
import { MediaVideo } from './media-video';

interface MediaProps extends PickedMediaImageProps {
  media: MediaValue;
  thumbnail?: boolean;
}

export function Media({
  className,
  media,
  alt,
  loaderColor,
  mode,
  onError,
  onLoad,
  backgroundColor,
  ratio,
  thumbnail = false
}: MediaProps) {
  const { postVideoAutoplay } = useSocialFeedSettings();

  const mediaImageProps = {
    className,
    alt,
    mode,
    ratio,
    backgroundColor,
    loaderColor,
    onLoad,
    onError
  };

  const mediaLinkProps = {
    mode,
    onLoad,
    onError
  };

  const showThumbnail = (() => {
    if (!thumbnail) {
      return false;
    }

    if (media.type === 'video') {
      return !postVideoAutoplay;
    }

    return true;
  })();

  if (showThumbnail) {
    const src = media.thumbnail || media.src;

    return <MediaImage src={src} {...mediaImageProps} />;
  }

  switch (media?.type) {
    case 'image':
      return <MediaImage src={media.src} {...mediaImageProps} />;
    case 'link':
      return (
        <MediaLink
          url={media.url}
          title={media.title}
          description={media.description}
          src={media.src}
          {...mediaLinkProps}
        />
      );
    case 'gallery':
      return <MediaCarousel items={media.items} {...mediaImageProps} />;
    case 'video':
      return <MediaVideo media={media} mediaImageProps={mediaImageProps} />;

    default:
      return null;
  }
}
